"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InlineTooltip_1 = require("./InlineTooltip");
exports.default = InlineTooltip_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tooltip/InlineTooltip/index.js
// module id = 1288
// module chunks = 8